import React, { createElement, ComponentClass, Component } from 'react';
import { DragSource, DropTarget, ConnectDropTarget, ConnectDragSource } from 'react-dnd';
import { DragSourceSpec } from 'react-dnd';
import { DropTargetSpec } from 'react-dnd';
import { DropTargetMonitor } from 'react-dnd';
import { DragSourceConnector } from 'react-dnd';
import { DragSourceMonitor } from 'react-dnd';
import { DropTargetConnector } from 'react-dnd';
import { ComponentDesc, ScreenComponentProps, store } from '../store';
import { flowRight } from 'lodash';
import { observer } from 'mobx-react';

import { FaGripVertical, FaLastfmSquare } from 'react-icons/fa';

import { openDialog } from './DialogElement';
import AddRowComponent from '../components/addRowDiv';

const trash = require('../components/icons/trash.svg');
const drag = require('../components/icons/drag.svg');
const clone = require('../components/icons/clone.svg');
const edit = require('../components/icons/edit_column.svg');

const style = {
    backgroundColor: 'white',
    cursor: 'move',
    position: 'relative',
    justifyContent: 'center',
};

const dragHandleStylesForComponent = {
    position: 'absolute',
    right: '-33px',
    top: '0px',
    background: '#373D49',
    color: '#373737',
    padding: '0px 5px',
    width: '25px',
    zIndex: 100,
    borderRadius: '6px',
    justifyContent: 'center',
    backgroundColor: 'rgb(253, 253, 253)',
    border: '0.5px solid #20d29f',
};

const dragHandleStylesForColumn = {
    position: 'absolute',
    zIndex: 100,
    backgroundColor: 'rgb(58, 54, 73)',
    borderRadius: '6px',
    right: '43px',
    top: 0,
    // padding: '8px',
    padding: '0px 5px',
    justifyContent: 'center',
    backgroundColor: 'rgb(253, 253, 253)',
    border: '0.5px solid #20d29f',
};

const dragHandleStylesForRow = {
    //border: '2px solid #D5EFF6',
};

export interface CardProps {
    id: any;
    index: number;
    component: ComponentClass<ScreenComponentProps<any>>;
    descriptor: ComponentDesc<any>;
    moveCard: (dragIndex: number, hoverIndex: number) => void;
    findCard: (id: number) => { card: any; index: number };

    isDragging?: boolean;
    isSelected?: boolean;
    isSelectedRow?: boolean;
    connectDragSource?: ConnectDragSource;
    connectDropTarget?: ConnectDropTarget;
}

class Card extends Component {
    // static propTypes = {
    // 	connectDragSource: PropTypes.func.isRequired,
    // 	connectDropTarget: PropTypes.func.isRequired,
    // 	isDragging: PropTypes.bool.isRequired,
    // 	id: PropTypes.any.isRequired,
    // 	text: PropTypes.string.isRequired,
    // 	moveCard: PropTypes.func.isRequired,
    // 	findCard: PropTypes.func.isRequired,
    // }

    state = {
        hover: false,
        addBtn: false,
    };

    shouldDisplayFlap(type: string, descriptor: ComponentDesc<any>) {
        if (type === 'column') {
            if (store.selectedRow) return store.selectedRow.id == descriptor.id;
            else return false;
        } else if (!store.leftPanelComponentDescriptor) {
            return false;
        } else {
            return store.leftPanelComponentDescriptor.id == descriptor.id;
        }
    }

    render() {
        const {
            isDragging,
            connectDragSource,
            connectDragPreview,
            connectDropTarget,
            component,

            removeCard,
            cloneCard,
            descriptor,

            type,
        }: any = this.props;
        let isSelected = store.leftPanelComponentDescriptor ? store.leftPanelComponentDescriptor.id === descriptor.id : false;

        let isSelectedRow = store.selectedRow ? store.selectedRow.id === descriptor.id : false;

        let border = isSelectedRow ? '1px solid #051931' : 'none';
        let outline = type === 'column' || !store.leftPanelComponentDescriptor ? 0 : isDragging ? 0 : isSelected ? '#757575 solid 1px' : 'none';
        let opacity = type === 'column' || !store.leftPanelComponentDescriptor ? 1 : isDragging ? 1 : isSelected ? 1 : 0.5;

        /* const opacity =
            type === 'row' || !store.selectedRow
                ? 1
                : isDragging
                ? 1
                : isSelectedRow
                ? 1
                : 0.3;*/

        let backgroundColor = type === 'row' || !store.selectedRow ? 'none' : isDragging ? 'none' : isSelectedRow ? 'white' : descriptor.fresh ? 'white' : 'white';

        let className = '';
        if (store.tempCard && store.tempCard.id === descriptor.id) {
            opacity = 0.2;
            className = 'overlay';
        }

        const Component = component;
        return connectDropTarget(
            connectDragPreview(
                <div
                    className={className}
                    style={
                        {
                            ...style,
                            border,
                            opacity,
                            backgroundColor,
                            outline,

                            ...(type === 'row' ? dragHandleStylesForRow : null),
                        } as any
                    }
                    onMouseEnter={(e) => {
                        if (type === 'column') {
                            if (store.ui.onHover === true) {
                                this.setState({ hover: true, addBtn: true });
                                store.selectedRow = store.getSelectedRow(undefined, descriptor.id);
                            }
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (type === 'column') {
                            if (store.ui.onHover === true && this.state.addBtn != false) {
                                this.setState({ hover: false, addBtn: false });
                                store.selectedRow = null;
                            }
                        }
                    }}
                    onClick={(e) => (type === 'column' ? store.getSelectedRow(undefined, descriptor.id) : null)}>
                    {type == 'column' && this.state.addBtn === true ? <AddRowComponent styleName="top" type="column" targetArray={store.currentTemplate.rows} targetIndex={store.getRowIndex(descriptor.id)} /> : null}
                    {/* {type === 'column' ? ( */}
                    <div
                        style={
                            {
                                ...(type === 'column' ? dragHandleStylesForColumn : dragHandleStylesForComponent),
                                display: this.shouldDisplayFlap(type, descriptor) ? 'block' : 'none',
                            } as any
                        }>
                        <img
                            style={{
                                padding: '5px',
                                display: 'table-cell',
                                height: '16px',
                                verticalAlign: 'middle',
                                // borderBottom: '1px solid white',
                                cursor: 'pointer',
                            }}
                            src={edit}
                            title="Edit"
                            onClick={(e) => {
                                if (type === 'column') {
                                    store.ui.left_panel_view = 'column_settings';
                                    store.getSelectedRow(undefined, descriptor.id);
                                } else {
                                    store.ui.left_panel_view = 'settings';
                                    store.getSelectedRow(descriptor.id);
                                }
                            }}
                        />

                        <img
                            style={{
                                padding: '5px',
                                display: 'table-cell',
                                height: '16px',
                                verticalAlign: 'middle',
                                // borderBottom: '1px solid white',
                                cursor: 'pointer',
                            }}
                            src={clone}
                            title="Copy"
                            onClick={(e) => cloneCard(descriptor)}
                        />

                        <img
                            style={{
                                padding: '5px',
                                display: 'table-cell',
                                height: '16px',
                                verticalAlign: 'middle',
                                //    borderBottom: '1px solid white',
                                cursor: 'pointer',
                            }}
                            onClick={(e) => {
                                openDialog('Delete Confirmation', 'Are you sure want to delete?', 1).then((res) => {
                                    res ? removeCard(descriptor.id) : null;
                                    store.ui.isConfirmationBoxOpen = false;
                                });
                            }}
                            src={trash}
                            title="Delete"
                        />

                        {type == 'column' && store.currentTemplate.rows.length != 1
                            ? connectDragSource(
                                  <img
                                      style={{
                                          padding: '5px',
                                          display: 'table-cell',
                                          height: '16px',
                                          verticalAlign: 'middle',
                                      }}
                                      src={drag}
                                      title="Move"
                                  />
                              )
                            : null}
                    </div>
                    {type == 'column' ? (
                        <Component descriptor={descriptor} />
                    ) : (
                        connectDragSource(
                            <div>
                                <Component descriptor={descriptor} />
                            </div>
                        )
                    )}
                    {type == 'column' && this.state.addBtn === true ? <AddRowComponent styleName="bottom" type="column" targetArray={store.currentTemplate.rows} targetIndex={store.getRowIndex(descriptor.id) + 1} /> : null}
                </div>
            )
        );
    }
}

const cardSource: DragSourceSpec<any, any> = {
    beginDrag(props) {
        return {
            id: props.id,
            //   originalIndex: props.findCard(props.id).index
            ...props.descriptor,
        };
    },

    endDrag(props, monitor) {
        const { id: droppedId, originalIndex } = monitor.getItem();
        const didDrop = monitor.didDrop();

        if (!didDrop) {
            // props.moveCard(droppedId, originalIndex);
        }
        return true;
    },
};

const cardTarget: DropTargetSpec<any> = {
    canDrop() {
        return true;
    },

    hover(props, monitor: DropTargetMonitor) {
        let { id: draggedId } = monitor.getItem();
        const { id: overId } = props;

        if (props.type == 'column' && !store.currentTemplate.rows.some((r) => r.id === draggedId)) {
            let card = monitor.getItem();
            store.tempCard = card;
            store.currentTemplate.rows.push(card);
        }

        if (draggedId !== overId) {
            const { index: overIndex } = props.findCard(overId);
            props.moveCard(draggedId, overIndex);
        }
    },

    drop(props: any, monitor: DropTargetMonitor, component: any) {
        let card = monitor.getItem();
        console.log('Wrapper: DROP', monitor.didDrop());

        if (store.currentTemplate.rows.some((r) => r.id === card.id)) {
            store.tempCard = null;
            return { handled: true };
        } else {
            return undefined;
        }
    },
};

function cardCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
    };
}

function cardSourceCollect(connect: DragSourceConnector, monitor: DragSourceMonitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    };
}

export default function(type: string) {
    return flowRight(
        DragSource(type, cardSource, cardSourceCollect),
        DropTarget(type, cardTarget, cardCollect),
        observer
    )(Card);
}
